export function ET_FX() {}

ET_FX.prototype.init = function () {
	var me = this;
	$(".et-fx--show-load").addClass("et-fx--loaded");

	$(".wp-block-buttons, .wp-block-p, .wp-block-image, .wp-block-heading").addClass("et-fx").addClass("et-fx--show-scroll").addClass("et-fx--hide-ty");

	$(".et-fx--tween-number").each(function () {
		$(this).attr("data-target", $(this).text());
		$(this).text("0");
	});

	$(document).scroll(function () {
		me.checkVisibleComponents();
	});
	me.checkVisibleComponents();
};

ET_FX.prototype.checkVisibleComponents = function () {
	var me = this;
	$(".et-fx.et-fx--show-scroll:not(.et-fx--loaded)").each(function () {
		if (me.isScrolledIntoView($(this))) {
			$(this).addClass("et-fx--loaded");
			if ($(this).find(".et-fx--tween-number").length > 0) {
				me.tweenCounters($(this));
			}
		}
	});
};

ET_FX.prototype.tweenCounters = function (elem) {
	const counters = $(elem).find(".et-fx--tween-number");

	var me = this;

	$(counters).each(function () {
		var item = this;

		$(this).attr("data-current", 0);

		let item_speed = parseFloat($(item).attr("data-target")).toFixed(1) / 50;

		function updateCount() {
			const target = $(item).attr("data-target");

			const counter = item;

			var count = parseFloat($(item).attr("data-current"));

			if (count < target) {
				count += item_speed;
				$(item).attr("data-current", count.toFixed(2));
				counter.innerText = me.numberWithDots(Math.min(Math.ceil(count), target));
				setTimeout(updateCount, 25);
			} else {
				counter.innerText = me.numberWithDots(parseFloat(target));
			}
		}

		updateCount();
	});
};

ET_FX.prototype.numberWithDots = function (x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

ET_FX.prototype.isScrolledIntoView = function (elem) {
	/*
    V003
  */
	//Compruebo si se ha llegado al final de la pantalla
	if ($(window).innerHeight() + $(window).scrollTop() >= $("body").height()) {
		return true;
	}
	//Si no compruebo estado del scroll relativo a la capa
	var $elem = $(elem);
	var $window = $(window);
	if ($elem.length == 0) {
		return false;
	}
	//return $window.scrollTop() > $elem.offset().top - $(window).height() * 0.7;
	var fire_number = $("#z-index-dummy").css("z-index") == 4 ? 90 : 150;
	return $window.scrollTop() > $elem.offset().top - $(window).height() + fire_number;
};
